document.addEventListener('DOMContentLoaded', function () {
    const isHoverableDevice = window.matchMedia(
        '(hover: hover) and (pointer: fine)'
    )

    //Check if the device is hoverable
    if (!isHoverableDevice.matches) return;

    document.querySelectorAll('.ats_vacancy_overview_columns').forEach((element) => {
        element.querySelectorAll('.animate-media').forEach((el) => {
            let cursor = el.querySelector('.follow-mouse');

            gsap.set(cursor, {xPercent: -50, yPercent: -50, opacity: 0, scale: 0});

            let xTo = gsap.quickTo(cursor, 'x', {duration: 0.2, ease: 'power3'});
            let yTo = gsap.quickTo(cursor, 'y', {duration: 0.2, ease: 'power3'});

            el.addEventListener('mouseenter', () => {
                gsap.to(cursor, {scale: 1, opacity: 1, delay: 0.2});
            });

            el.addEventListener('mousemove', e => {
                xTo(e.clientX);
                yTo(e.clientY);
            });

            el.addEventListener('mouseleave', () => {
                gsap.to(cursor, {scale: 0, opacity: 0, delay: 0.2});
            });
        });
    });
});
